import * as React from 'react';

import * as styles from './styles.css';

export interface INewbuildingGenplanPreviewProps {
  onClick(): void;
  imageUrl: string;
}

export const NewbuildingGenplanPreview: React.FC<INewbuildingGenplanPreviewProps> = ({ onClick, imageUrl }) => {
  return <div className={styles['preview']} onClick={onClick} style={{ backgroundImage: `url(${imageUrl})` }} />;
};
